module.exports = __webpack_public_path__ + "static/rpm_avanzada-996e856d649c001be11d0c340e732225.png";